<template>
    <div class="col-auto position-relative d-flex justify-content-center align-items-center">
        <span class="badge badge-pill badge-primary position-absolute pos-t-0 pos-r-1 text-label">{{counter}}</span>
        <span class="icon-bell icon-s"></span>
    </div>
</template>
<script>
  export default {
    name: 'notification',
    props:['counter']
  }
</script>
